import { useLocation } from "react-router-dom";
import { appConfig } from "@/config/app";
import { normalizePath, pageMetadata, seoPaths } from "@/config/seo";
import { usePageMeta } from "./usePageMeta";

function Metadata({ path }: { path: string }) {
  const meta = pageMetadata(path, appConfig.name, appConfig.domain);
  usePageMeta(meta.title, meta.description, path);
  return null;
}

/** Les pages publiques possèdent leurs métadonnées ; les autres ne s’indexent pas. */
export function PrivatePageMetadata() {
  const { pathname } = useLocation();
  return seoPaths.includes(normalizePath(pathname)) ? null : <Metadata path={pathname} />;
}
